<template>
  <div class="deptListPage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入搜索关键词"
      show-action
      shape="round"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in deptMainList"
              clickable
              :key="item.id"
              :title="`${item.departmentName}`"
              @click="selectitem(item)"
              class="item"
            >
              <!-- <van-checkbox
                :name="item.departmentName"
                ref="checkboxes"
                slot="right-icon"
              /> -->
              <van-radio slot="right-icon" :name="`${item.departmentName}`" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeDeptPicker">取消</a>
      <a href="javascript:void(0);" class="fl" @click="saveDeptData">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
export default {
  name: "deptList",
  data() {
    return {
      searchName: "",
      searchKeyword: "", //搜索的部门id
      total: "", //统计计算
      radio: "",
      redioRetinuedata: {},
      deptMainList: [],
      deptViewList: [], //部门列表
      page: 0,
      pageSize: 99,

      result: [], //选择的部门列表
      deptData: [], //选中的部门列表
      cloneRetinuedata: [],
      retinueIdList: [],
      retinueNameList: "",
      // page: 0,
      // pageSize: 20,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    retinueUid: {
      type: String,
    },
  },

  mounted() {
    console.log(this.retinueUid)
    this.getDeptList();
  },
  methods: {
    // toggle(index, item) {
    //   this.$refs.checkboxes[index].toggle();
    //   this.deptData.push(item);
    //   this.unique(this.deptData);
    // },
    selectitem(data) {
      let _this = this;
      console.log(data);
      _this.radio = data.departmentName;
      _this.redioRetinuedata = data;
    },
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getDeptList() {
      let _this = this;
      _this.$api.baseCommon.baseMsg
        .getDeptList({ stationOrgId: _this.searchKeyword })
        .then((res) => {
          if (res.code == "1") {
            _this.deptViewList = res.data;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;
            _this.finished = true;
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          _this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      let _this = this;
      _this.deptMainList = _this.deptViewList;
      console.log(_this.retinueUid,'2222222222_this.deptMainList')
      _this.radio = "",_this.redioRetinuedata={};
      _this.handleData();
    },
    handleData(){
      let _this = this;
      _this.deptMainList.forEach((item) => {
        if (_this.retinueUid && _this.retinueUid == item.id) {
          _this.radio = item.departmentName;
          _this.redioRetinuedata = item;
        }
      });
    },
    closeDeptPicker() {
      this.$emit("setDeptData", "");
      let _this = this;
      _this.handleData();
    },
    saveDeptData() {
      let _this = this;
      this.$emit("setDeptData", _this.redioRetinuedata);
      // this.radio = "";
    },
    
    reloadPage() {
      this.page = 0;
      this.deptMainList = [];
      this.deptViewList=[];
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      this.getDeptList();
    },
  },
  watch: {
    retinueUid: function (newVal) {
      console.log(newVal,'newValnewValnewVal')
      if(newVal){
        this.retinueUid = newVal;
        this.reloadPage()
      }else{
        this.radio = "";
        this.retinueUid = "";
        this.reloadPage()
      }
    },
  },
};
</script>
<style lang="less" >
.deptListPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-content {
    height: calc(100% - 95px);
    overflow: scroll;
    padding-bottom: 50px;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    background-color: #fff;
    text-align: center;
    color: #333;
    height: 45px;
    bottom: 0;
    z-index: 999;
    border-top: 1px solid #f6f6f6;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>